import React, { useEffect, useState } from 'react'
import UtilityService from '../../services/UtillityServices/UtilityService';
import useAgenzie from '../../hooks/useAgenzie';
import HorizontalCourseCard from '../HorizontalCourseCard/HorizontalCourseCard';
import { ROLES } from '../../model/roles';
import CustomSlider from '../CustomSlider/CustomSlider';
import { alertService } from '../../services/AlertService';
import useClassi from '../../hooks/useClassi';
import CustomSearch from '../CustomSearch/CustomSearch';
import useSconti from '../../hooks/useSconti';
import useSuperpartner from '../../hooks/useSuperpartner';

const CreateUser = ({selectedAgenzia, setSelectedAgenzia, userLoggedIn, formCreateUtente, setFormCreateUtente, showModalCreateUtente, corsiUtentiAssignedPerUser, setCorsiUtentiAssignedPerUser, formatCourseData}) => {
  const [rolesList, setRolesList] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [maxScontoPartner, setMaxScontoPartner] = useState(null);
  const [remainingVoucherPartner, setVoucherPartner] = useState(null);//NEW
  const [idActiveVoucherPartner, setActiveVoucherPartner] = useState(null);//NEW
  const {getScontoByIdCorso, loadingStateSconti} = useSconti();
  const {getVoucherByIdCorso, loadingStateVoucher} = useSconti();//NEW
  const {getAllSuperpartner, loadingStateSuperpartner} = useSuperpartner();
  const {getAgenzieByParams} = useAgenzie();
  const { getClassiByParamsNoAuth } = useClassi();
  const [paymentOption, setPaymentOption] = useState('self');
  const [voucherOption, setVoucherOption] = useState("1");
  const [selfOption, setSelfOption] = useState("1");//NEW
  const [shouldAssignCourse, setShouldAssignCourse] = useState(false);
  const [showAgenzieList, setShowAgenzieList] = useState(false);
  const [classiDisponibili, setClassiDisponibili] = useState([]);
  const [superpartnerList, setSuperpartnerList] = useState([]);

  useEffect(() => {
      if(!showModalCreateUtente) {
          setFormCreateUtente({});
      }
    }, [showModalCreateUtente])  

    useEffect(() => {
      if(selectedRole === "partner") {
        fetchSuperpartner();
      }
    }, [selectedRole])  

  useEffect(() => {
      const rolesList = UtilityService.rolesAllowedToCreate(userLoggedIn);
      setRolesList(rolesList);
  }, [])

  useEffect(() => {
    if(!showAgenzieList){
      setSelectedAgenzia(null);
      setFormCreateUtente({...state => delete state.id_agenzia})
    }
  }, [showAgenzieList])

  useEffect(() => {
    if(selectedAgenzia) {
      setFormCreateUtente((prevState) => ({ ...prevState, id_agenzia: selectedAgenzia?.id_agenzia }));
    }
  }, [selectedAgenzia])

  useEffect(() => {
    if(selectedCourse && userLoggedIn.tipo_utente === "partner" && paymentOption === "corsista" && voucherOption === "1") {
      fetchMaxScontoPartner();
    }

    if(selectedCourse && userLoggedIn.tipo_utente === "partner" && selfOption === "0") {//NEW
      fetchVoucherPartner();
    }
  }, [selectedCourse])

  useEffect(() => {//NEW
    if (formatCourseData) {
      setSelectedCourse(formatCourseData);
      if (userLoggedIn.tipo_utente === "partner" && selfOption === "0") {
        fetchVoucherPartner();
      }
    }
  }, [formatCourseData, userLoggedIn.tipo_utente, selfOption]);

  useEffect(() => {
    if(selectedCourse && userLoggedIn.tipo_utente === "partner" && paymentOption === "corsista" && voucherOption === "1") {
      fetchMaxScontoPartner();
    }
  }, [paymentOption])

  useEffect(() => {
    const fetchClassiDisponibili = async () => {
      if (userLoggedIn?.role === ROLES.PARTNER) {
        const response = await getClassiByParamsNoAuth({//NEW
                                                        filtri: {
                                                          stato: 'Attivo'
                                                        },
                                                        usern: localStorage.getItem("username")//NEW
                                                      });
        setClassiDisponibili(response?.data ?? []);
      }
    };
    fetchClassiDisponibili();
  }, [userLoggedIn]);

  useEffect(() => {//NEW
    if (userLoggedIn.role === ROLES.PARTNER) {
        setFormCreateUtente((prevState) => ({ ...prevState, ruolo: "corsista" }));
        setSelectedRole("corsista");
    }
  }, [userLoggedIn]);

  useEffect(() => {//NEW
    if (formatCourseData && formatCourseData.id_classe) {
      setSelectedCourse(formatCourseData);  // Pre-seleziona il corso passato
    }
  }, [formatCourseData]);

  const fetchSuperpartner = async () => {
    const response = await getAllSuperpartner();
    setSuperpartnerList(response ?? []);
  }

  const fetchMaxScontoPartner = async () => {
    const response = await getScontoByIdCorso({id_corso: selectedCourse?.corso.id_corso});
    setMaxScontoPartner(response?.sconto);
  }

  const fetchVoucherPartner = async () => {//NEW
    const response = await getVoucherByIdCorso({id_corso: selectedCourse?.corso.id_corso});
    setVoucherPartner(response?.qt_available);
    setActiveVoucherPartner(response?.id_utenti_voucher);
  }

  const renderAgenzie = () => {
    if(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) {
      return (
      <div className='col-12 my-3'>
           <CustomSearch
            field={"denominazione"}
            label={"Cerca agenzia"}
            searchApi={getAgenzieByParams}
            placeholder={"Nome dell'agenzia"}
            selectedItem={selectedAgenzia}
            setSelectedItem={setSelectedAgenzia}
            />
           { selectedAgenzia && (
              <>
              <span className='small text-muted d-block mb-1'><b>Agenzia selezionata</b></span>
              <span>{selectedAgenzia.denominazione} ({selectedAgenzia.indirizzo}, {selectedAgenzia.cap}, {selectedAgenzia.citta}, {selectedAgenzia.provincia})</span>
              </>
           )
           }
       </div>
      )
    } 
    return null;
  }

  const handleFormChange = e => {
      const { name, value } = e.target;
      
      if (name === 'sconto') {
        const numValue = Number(value);
        if (numValue < 0) return;
        if (numValue > maxScontoPartner) return;
      }
      
      setFormCreateUtente(prevState => ({ ...prevState, [name]: value }));
    }

  const handleRoleChange = (event) => {
      const selectedOption = event.target.value;
      setSelectedRole(selectedOption)
      setFormCreateUtente((prevState) => ({ ...prevState, ruolo: selectedOption }));
  }

  const handleStatoPagamentoChange = (event) => {
    const selectedOption = event.target.value;
    setFormCreateUtente((prevState) => ({ ...prevState, stato_pagamento: selectedOption }));
}

  const handlePaymentOptionChange = (e) => {
    setPaymentOption(e.target.value);
  };

  const handleVoucherOptionChange = (e) => {
    setVoucherOption(e.target.value);
  };

  // const handleSelfOptionChange = (e) => {//NEW
  //   setSelfOption(e.target.value);
  // };

  const handleSelfOptionChange = (e) => {//NEW
    const newValue = e.target.value;
    setSelfOption(newValue);

    // Rimuovi il corso se cambia selezione da Stripe a Voucher o viceversa
    if (selectedCourse?.id_classe) {
      removeCourse(selectedCourse.id_classe); // simula il click sull'icona trash
    }
  };

  const handleCheckboxCorsiChange = (isChecked) => {
    setShouldAssignCourse(isChecked);
  };

  const handleCheckboxAgenzieChange = (isChecked) => {
    setShowAgenzieList(isChecked);
  };

  const onAssignCourse = () => {
    if(selectedCourse) {
      if(paymentOption == "self" && selfOption == "0" && (remainingVoucherPartner == 0 || remainingVoucherPartner === undefined)){//NEW
        alertService.warn("Nessun voucher disponibile per questo corso! Seleziona un'altra modalità di pagamento...", {autoClose: true});
      }
      else{
        if (!corsiUtentiAssignedPerUser.some(corso => corso?.id_classe === selectedCourse?.id_classe)) {
          if(userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DEVELOPER){
            selectedCourse.stato_pagamento = formCreateUtente.stato_pagamento;
            if(selectedRole === "corsista" && selectedCourse.stato_pagamento !== "Non_pagato" && selectedCourse.stato_pagamento !== "Pagato" && selectedCourse.stato_pagamento !== "Parzialmente_pagato"){
              alertService.warn("Seleziona uno stato di pagamento del corso", {autoClose: true});
              return;
            }
          }
          
          if(userLoggedIn?.role === ROLES.PARTNER){
            selectedCourse.pagamento_partner = (paymentOption == "corsista" ? "0" : "1");
            selectedCourse.pagamento_self = selfOption;//NEW
            selectedCourse.sconto_corsista = (voucherOption == "1" && selectedCourse.pagamento_partner == "1") ? "0" : voucherOption;
            if(paymentOption == "corsista" && voucherOption == "1") {
              if(!formCreateUtente?.sconto) {
                alertService.warn("Inserisci un valore per lo sconto", {autoClose: true});
                return;
              }
              selectedCourse.sconto = formCreateUtente?.sconto;
            } else {
              delete formCreateUtente?.sconto;
              delete selectedCourse?.sconto;
            }
          }
          setCorsiUtentiAssignedPerUser(prev => [...prev, selectedCourse]);
        } else {
          alertService.warn("Il corso è già stato assegnato all'utente", {autoClose: true});
        }
      }
    } else {
      alertService.warn("Seleziona un corso da assegnare all'utente", {autoClose: true});
    }
  }

  const removeCourse = (classIdToRemove) => {
    setCorsiUtentiAssignedPerUser(prevCourses => prevCourses.filter(course => course.id_classe !== classIdToRemove));
  };

  const renderPartnerPaymentOptions = () => (
  <div className="col-12 my-3">
       <span className='small text-muted d-block mb-1'><b>Pagamento</b></span>
      <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
            <input
              type="radio"
              className="btn-check"
              name="paymentOption"
              id="selfPayment"
              value="self"
              autoComplete="off"
              checked={paymentOption === 'self'}
              onChange={handlePaymentOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="selfPayment">
              Pagamento a proprio carico
            </label>

            <input
              type="radio"
              className="btn-check"
              name="paymentOption"
              id="corsistaPayment"
              value="corsista"
              autoComplete="off"
              checked={paymentOption === 'corsista'}
              onChange={handlePaymentOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="corsistaPayment">
              Pagamento a carico del corsista
            </label>
          </div>
  </div>
  )

  const renderPartnerVoucherOptions = () => (
  <div className="col-12 my-3">
       <span className='small text-muted d-block mb-1'><b>Applica sconto</b></span>
      <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
            <input
              type="radio"
              className="btn-check"
              name="voucherOption"
              id="yes-voucher"
              value="1"
              autoComplete="off"
              checked={voucherOption === "1"}
              onChange={handleVoucherOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="yes-voucher">
              Applica
            </label>

            <input
              type="radio"
              className="btn-check"
              name="voucherOption"
              id="no-voucher"
              value="0"
              autoComplete="off"
              checked={voucherOption === "0"}
              onChange={handleVoucherOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="no-voucher">
              Non applicare
            </label>
          </div>
  </div>
  )

  const renderPartnerSelfOptions = () => (//NEW
    <div className="col-12 my-3">
         <span className='small text-muted d-block mb-1'><b>Seleziona modalità di pagamento</b></span>
        <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name="selfOption"
                id="transfer"
                value="1"
                autoComplete="off"
                checked={selfOption === "1"}
                onChange={handleSelfOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="transfer">
                Carta (Stripe)
              </label>
  
              <input
                type="radio"
                className="btn-check"
                name="selfOption"
                id="voucher"
                value="0"
                autoComplete="off"
                checked={selfOption === "0"}
                onChange={handleSelfOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="voucher">
                Voucher
              </label>
            </div>
    </div>
  )

  const renderStatoPagamento = () => {
    if(userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DEVELOPER) {
      return (
      <div className='col-12 my-3'>
        <span className='small text-muted d-block mb-1'><b>Stato pagamento</b></span>
        <select name="stato_pagamento" className="form-control" value={formCreateUtente.stato_pagamento || ''} onChange={handleStatoPagamentoChange}>
        <option value="">Seleziona uno stato di pagamento</option>
          <option value="Pagato">Pagato</option>
          <option value="Non_pagato">Non pagato</option>
          <option value="Parzialmente_pagato">Parzialmente pagato</option>
        </select>
      </div>
      )
    }
    return null;
  }

  const handleSuperpartnerChange = (e) => {
    setFormCreateUtente((prevState) => ({ ...prevState, id_superpartner: e.target.value }));
  }

  const renderSuperpartner = () => {
    return (
      <div>
            <span className='small text-muted d-block mb-1'><b>Superpartner</b></span>
            {
             loadingStateSuperpartner.isLoadingSuperpartner ? (
              <div className="text-center py-3">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Caricamento...</span>
                </div>
              </div>
             ) : (
              <select name="superpartner" className="form-control" value={formCreateUtente.id_superpartner || ''} onChange={handleSuperpartnerChange}>
                <option value="nessuno">Nessuno</option>
                {superpartnerList.map(superpartner => (
                  <option key={superpartner.id_superpartner} value={superpartner.id_superpartner}>{superpartner.nome}</option>
                ))}
              </select>
            )
          }
      </div>
    )
  }

  const renderVoucher = () => {//NEW
    if(loadingStateVoucher.isLoadingScontoByIdCorso) {
      return (
        <div className="text-center py-3">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </div>
        </div>
      );
    }
    if (paymentOption == "self" && selfOption === "0") {
      if(remainingVoucherPartner == 0 || remainingVoucherPartner === undefined){
        return (
          <div className="alert alert-warning mt-3" role="alert">
            <i className="bi bi-exclamation-triangle me-2"></i>
            <small>Nessun voucher disponibile per questo corso.</small>
          </div>
        );
      }
      return (
        <div className="alert alert-primary" role="alert">
            <i className="bi bi-info-circle me-2"></i>
            <small>Hai ancora a disposizione {remainingVoucherPartner} voucher per questo corso</small>
        </div>
      );
    }
  }

  const renderSconti = () => {
    if(loadingStateSconti.isLoadingScontoByIdCorso) {
      return (
        <div className="text-center py-3">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </div>
        </div>
      );
    }

    if (paymentOption == "corsista" && voucherOption === "1" && !maxScontoPartner) {
      return (
        <div className="alert alert-warning mt-3" role="alert">
          <i className="bi bi-exclamation-triangle me-2"></i>
          <small>Non è disponibile alcuno sconto per questo corso.</small>
        </div>
      );
    }
    
    return (
      paymentOption === "corsista" && voucherOption === "1" && (
        <div className="my-3">
          <div className="alert alert-primary" role="alert">
            <i className="bi bi-info-circle me-2"></i>
            <small>
              Lo sconto massimo applicabile è di <strong>{maxScontoPartner}€</strong>. 
              La differenza tra lo sconto massimo e quello applicato costituirà la tua provvigione.
            </small>
          </div>
          
          <div className="form-group">
            <span className='d-block text-muted mb-2'>
              <b>Inserisci sconto per il corsista (in €)</b>
            </span>
            <input 
              name="sconto" 
              value={formCreateUtente.sconto || ''} 
              onChange={handleFormChange} 
              className="form-control" 
              type="number"
              min="0"
              max={maxScontoPartner}
              step="0.01"
              onKeyDown={(e) => {
                if(['e', 'E', '+', '-'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              placeholder={`Sconto massimo: ${maxScontoPartner}€`} 
              aria-label="Sconto"
            />
            <small className="text-muted mt-1 d-block">
              Esempio: se applichi uno sconto di 100€ su uno sconto massimo di 300€, la tua provvigione sarà di 200€
            </small>
          </div>
        </div>
      )
    );
  }

return (
  <>
  <div className='col-12'>
      <span className='small text-muted d-block mb-1'><b>Nome</b></span>
      <input name="nome" value={formCreateUtente.nome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Nome" aria-label="Nome"/>
 </div>
  <div className='col-12 my-3'>
      <span className='small text-muted d-block mb-1'><b>Cognome</b></span>
      <input name="cognome" value={formCreateUtente.cognome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Cognome" aria-label="Cognome"/>
 </div>
  <div className='col-12 my-3'>
      <span className='small text-muted d-block mb-1'><b>Email</b></span>
      <input name="email" value={formCreateUtente.email || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Email" aria-label="Email"/>
 </div>
  <div className='col-12 my-3'>
  <span className='small text-muted d-block mb-1'><b>Ruolo</b></span>
  <select name="ruolo" className="form-control" value={formCreateUtente.ruolo || ''} onChange={handleRoleChange}>
      <option value="">Seleziona un ruolo</option>
      {rolesList?.map((option, index) => (
      <option key={index} value={option}>{option === "course_designer" ? "course designer" : option}</option>
      ))
      }
  </select>
 </div>
 {(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && (
   selectedRole === "partner" && (
       <>
    <div className='my-2'>
      {renderAgenzie()}
      {renderSuperpartner()}
    </div>
    </>
   )
  )}
   {(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && (
    (selectedRole === "corsista") && (
    <div className='my-2'>
    <CustomSlider 
        handleSliderChange={handleCheckboxAgenzieChange}
        labelText="Vuoi assegnare un'agenzia all'utente?"
        />
      {showAgenzieList && (
        renderAgenzie()
       )
       }
    </div>
    )
   )}

{(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && (
  (selectedRole === "tutor" || selectedRole === "docente" || selectedRole === "course_designer") && (
    <>
    <CustomSlider 
    handleSliderChange={handleCheckboxCorsiChange}
    labelText="Vuoi assegnare dei corsi all'utente?"
    isChecked={shouldAssignCourse}
    />
     {shouldAssignCourse && ( 
      <>
        <div className='col-12 my-3'>
        <CustomSearch
            field={"denominazione_corso"}
            label={"Cerca corso"}
            searchApi={getClassiByParamsNoAuth}
            placeholder={"Nome del corso"}
            selectedItem={selectedCourse}
            setSelectedItem={setSelectedCourse}
            showDate={true}
              />
        {selectedCourse && (
            <>
            <span className='small text-muted d-block mb-1'><b>Corso selezionato</b></span>
            <span>{selectedCourse?.corso?.denominazione}
            {
              selectedCourse?.corso?.modalita_erogazione !== "Telematica_Asincrona" && (
                <>
                {" "}({selectedCourse?.data_inizio ? UtilityService.formatDate(selectedCourse?.data_inizio) : ""} - {selectedCourse?.data_fine ? UtilityService.formatDate(selectedCourse?.data_fine) : ""})
                </>
              )
            }
            
            </span>
            </>  
          ) }
       </div>
        <div className='col-12 my-3'>
          <button className='btn btn-primary my-3 w-100' onClick={onAssignCourse}>Assegna corso</button>
        </div>
        <div className='mt-3'>
        {corsiUtentiAssignedPerUser?.length > 0 ? (
        <>
          <span className='d-block text-muted'><b>Lista corsi</b></span>
          {corsiUtentiAssignedPerUser?.map(corso => (
            <div key={corso.id_classe} >
              <HorizontalCourseCard
                cardStyle={"shadow"} 
                course={corso}
                selectedRole={selectedRole}
                onRemoveCourse={removeCourse}
                userLoggedIn={userLoggedIn}
                />
            </div>
          ))}
        </>
      ) : (
        <p className='mt-5 text-center'>Nessun corso assegnato all'utente.</p>
      )}
    </div>
        </>
     ) 
     } 
    </>    
    )
  )}

   {(userLoggedIn?.role === ROLES.PARTNER || userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) &&
      (selectedRole === "corsista") && (
        <>
        {
          userLoggedIn?.role !== ROLES.PARTNER && (
            <CustomSlider 
            handleSliderChange={handleCheckboxCorsiChange}
            labelText="Vuoi assegnare dei corsi all'utente?"
            />
          )
        }
         {(shouldAssignCourse || userLoggedIn?.role === ROLES.PARTNER) && ( 
          <>
           {renderStatoPagamento()}
           {(userLoggedIn?.role === ROLES.PARTNER) && (
            <>
            {renderPartnerPaymentOptions()}
            {
              paymentOption === "corsista" && (
                renderPartnerVoucherOptions()
              )
            }
            {//NEW
              paymentOption === "self" && (
                renderPartnerSelfOptions()
              )
            }
            </>
            )}

            {
            (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER )&& (
              <div className='col-12 my-3'>
              <CustomSearch
                  field={"denominazione_corso"}
                  label={"Cerca corso"}
                  searchApi={getClassiByParamsNoAuth}
                  placeholder={"Nome del corso"}
                  selectedItem={selectedCourse}
                  setSelectedItem={setSelectedCourse}
                  showDate={true}
                    />
              {selectedCourse && (
                  <>
                  <span className='small text-muted d-block mb-1'><b>Corso selezionato</b></span>
                  <span>{selectedCourse?.corso?.denominazione}
                  {
                    selectedCourse?.corso?.modalita_erogazione !== "Telematica_Asincrona" && (
                      <>
                      {" "}({selectedCourse?.data_inizio ? UtilityService.formatDate(selectedCourse?.data_inizio) : ""} - {selectedCourse?.data_fine ? UtilityService.formatDate(selectedCourse?.data_fine) : ""})
                      </>
                    )
                  }
                  
                  </span>
                  </>  
                ) }
             </div>
             )}

            {
            userLoggedIn?.role === ROLES.PARTNER && (
                <>
          <div className='col-12 my-3'>
            <div className='col-12 my-3'>
              <span className='small text-muted d-block mb-1'><b>Seleziona corso</b></span>
              <select 
                className="form-control" 
                value={selectedCourse?.id_classe || ''} 
                onChange={(e) => {
                  const selected = classiDisponibili.find(c => c.id_classe === parseInt(e.target.value));
                  setSelectedCourse(selected);
                }}
              >
                <option value="">Seleziona un corso</option>
                {classiDisponibili.map(classe => (
                  <option key={classe.id_classe} value={classe.id_classe}>
                    {classe.corso.denominazione}
                    {classe.corso.modalita_erogazione !== "Telematica_Asincrona" && 
                      ` (${UtilityService.formatDate(classe.data_inizio)} - ${UtilityService.formatDate(classe.data_fine)})`
                    }
                  </option>
                ))}
              </select>
            </div>
            {selectedCourse && (
                <>
                <span className='small text-muted d-block mb-1'><b>Corso selezionato</b></span>
                <span>{selectedCourse?.corso?.denominazione}
                  {
                    selectedCourse?.corso?.modalita_erogazione !== "Telematica_Asincrona" && (
                      <>
                      {" "}({selectedCourse?.data_inizio ? UtilityService.formatDate(selectedCourse?.data_inizio) : ""} - {selectedCourse?.data_fine ? UtilityService.formatDate(selectedCourse?.data_fine) : ""})
                      </>
                    )
                  }
                </span>
                {
                  renderSconti()
                }
                {//NEW
                  paymentOption === "self" && (
                    renderVoucher()
                  )
                }
                </>  
              ) }
          </div>
          </>
          ) }
          <div className='col-12 my-3'>
            <button className='btn btn-primary my-3 w-100' onClick={onAssignCourse} disabled={paymentOption == "corsista" && voucherOption === "1" && !maxScontoPartner}>Assegna corso</button>
            </div>
            <div className='mt-3'>
          {corsiUtentiAssignedPerUser?.length > 0 ? (
            <>
              <span className='d-block text-muted'><b>Lista corsi</b></span>
              {corsiUtentiAssignedPerUser?.map(corso => (
                <div key={corso.id_classe} >
                  <HorizontalCourseCard
                    cardStyle={"shadow"} 
                    course={corso}
                    userLoggedIn={userLoggedIn}
                    selectedRole={selectedRole}
                    isCreateUserView={true}
                    onRemoveCourse={removeCourse}
                    />
                </div>
              ))}
            </>
          ) : (
            <p className='mt-5 text-center'>Nessun corso assegnato all'utente.</p>
          )}
        </div>
          </>
         ) 
         } 
        </>
  )}
  </>
)
}

export default CreateUser;